/**
 * Wine club tier rows from getWineClubData().settings, e.g.
 * { quantity, discount, shippingType: "flat"|"percentage"|"free", shippingValue }
 */

export function toTier(setting) {
  const st = String(setting?.shippingType ?? setting?.shipping_type ?? "").toLowerCase();
  const minBottles =
    Number(setting?.minBottles ?? setting?.min_bottles ?? setting?.quantity) || 0;
  const discountPercent =
    Number(setting?.discount ?? setting?.discountPercent ?? setting?.discount_percent) || 0;
  const shippingValue =
    Number(setting?.shippingValue ?? setting?.shipping_value ?? 0) || 0;

  let shippingType = "flat";
  if (st === "free") shippingType = "free";
  else if (st === "percentage") shippingType = "percentage";
  else if (st === "flat") shippingType = "flat";

  return {
    minBottles,
    discountPercent,
    shippingType,
    shippingValue,
    raw: setting,
  };
}

export function buildTiersFromSettings(settings) {
  if (!Array.isArray(settings) || !settings.length) return [];
  const tiers = settings.map(toTier).filter((t) => t.minBottles > 0);
  if (!tiers.length) return [];
  return [...tiers].sort((a, b) => b.minBottles - a.minBottles);
}

export function getTierForCount(tiers, currentItems) {
  if (!Array.isArray(tiers)) return null;
  for (const tier of tiers) {
    if (currentItems >= tier.minBottles) return tier;
  }
  return null;
}

export function getNextTier(tiers, currentItems) {
  if (!tiers?.length) return null;
  return [...tiers].reverse().find((t) => t.minBottles > currentItems) ?? null;
}

export function computeShippingCost(tier, orderSubtotal) {
  if (!tier) return 0;
  if (tier.shippingType === "free") return 0;
  if (tier.shippingType === "flat") {
    return Math.max(0, Number(tier.shippingValue) || 0);
  }
  if (tier.shippingType === "percentage") {
    const pct = Math.max(0, Number(tier.shippingValue) || 0);
    return (Math.max(0, Number(orderSubtotal) || 0) * pct) / 100;
  }
  return Math.max(0, Number(tier.shippingValue) || 0);
}

export function formatTierShippingPreview(tier) {
  if (!tier) return "";
  if (tier.shippingType === "free") return "free shipping";
  if (tier.shippingType === "flat") {
    const v = Number(tier.shippingValue) || 0;
    return v === 0 ? "free shipping" : `$${v} shipping`;
  }
  if (tier.shippingType === "percentage") {
    return `${tier.shippingValue}% order shipping`;
  }
  return "";
}
